export const HEX_COLOR_REGEX = /^#(?:[0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
export const LANGUAGE_CODE_REGEX = /^[A-Za-z]{2,3}(?:-[A-Za-z0-9]{2,8})*$/;
export const FILE_REFERENCE_REGEX =
  /^(?:\/[A-Za-z0-9._~!$&'()*+,;=:@%/-]*|[A-Za-z0-9._-]+(?:\/[A-Za-z0-9._-]+)*)$/;
export const DOMAIN_REGEX =
  /^(?=.{1,253}$)(?!-)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/i;
export const IPV4_REGEX =
  /^(?:(?:25[0-5]|2[0-4]\d|1?\d?\d)\.){3}(?:25[0-5]|2[0-4]\d|1?\d?\d)$/;

export function getApiErrorMessage(error, fallbackMessage) {
  return (
    error?.data?.msg ||
    error?.data?.message ||
    error?.message ||
    fallbackMessage
  );
}

export function mapValidationErrors(error) {
  const items = Array.isArray(error?.data?.errors) ? error.data.errors : [];
  return items.reduce((accumulator, item) => {
    const path = String(item?.path || "").trim();
    if (path && !accumulator[path]) {
      accumulator[path] = item?.msg || "Invalid value.";
    }
    return accumulator;
  }, {});
}

export function isSafeAssetReference(value) {
  const normalized = String(value || "").trim();
  if (!normalized) return true;
  if (normalized.includes("..")) return false;

  try {
    const parsedUrl = new URL(normalized);
    return ["http:", "https:"].includes(parsedUrl.protocol);
  } catch (_) {
    return FILE_REFERENCE_REGEX.test(normalized);
  }
}

export function isValidTimezone(value) {
  const timezone = String(value || "").trim();
  if (!timezone) return false;

  try {
    Intl.DateTimeFormat("en-US", { timeZone: timezone }).format(new Date());
    return true;
  } catch (_) {
    return false;
  }
}

export function normalizeAssetReference(value = {}) {
  return {
    url: String(value?.url || "").trim(),
    publicId: String(value?.publicId || "").trim(),
  };
}

export function toAssetPayload(value = {}) {
  const asset = normalizeAssetReference(value);
  return asset.url || asset.publicId ? asset : undefined;
}

export function splitKeywords(value) {
  if (!String(value || "").trim()) return [];

  return [...new Set(
    String(value)
      .split(",")
      .map((item) => item.trim().toLowerCase())
      .filter(Boolean)
  )];
}

export function formatDateTime(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}
